import { Capacitor } from '@capacitor/core';
import {
  ToastOptions,
  loadingController,
  LoadingOptions,
  alertController,
  AlertOptions,
} from '@ionic/core';
import { translate } from '../global/translate';
import {
  isOnBetaWebApp,
  isOnProdWebApp,
  betaWebAppURL,
  getEnvFromState,
} from '../global/utils';
import { swApi } from '../global/app';
import { showNewVersionAvailableToast, showGlobalToast } from '../global/toast';
import { updateUserAccount } from './user';
import { trackIntercomEvent } from '../global/intercom';
import { TypeKeys } from '.';
import { amplitudeLogEvent, AmplitudeEvents } from '../global/amplitude';
import { updateAccount } from '../global/firestore-user';

export interface CheckForUpdate {
  type: TypeKeys.CHECK_FOR_UPDATE;
}

export const checkForUpdate = () => async (dispatch, getState) => {
  const action: CheckForUpdate = {
    type: TypeKeys.CHECK_FOR_UPDATE,
  };
  await dispatch(action);
  const channel = getEnvFromState(getState());
  if (Capacitor.isNativePlatform()) {
    // return dispatch(downloadAndExtractUpdateFromChannel(channel));
  } else {
    const onProdWebApp = isOnProdWebApp();
    const onBetaWebApp = isOnBetaWebApp();
    if (onBetaWebApp && channel == 'prod') {
      dispatch(showOnBetaJoinBetaAlert());
    } else if (onProdWebApp && channel == 'beta') {
      showOnProdWebsiteGoToBeta();
    } else {
      if (swApi.env == channel) return;
      // User preference doesn't match sw-api data.
      // Should update sw-api data via refresh
      dispatch(setUpdateAvailable(true));
      return showNewVersionAvailableToast();
    }
  }
};

const showOnBetaJoinBetaAlert = () => async (dispatch, _getState) => {
  const options: AlertOptions = {
    subHeader: translate('ON_BETA_JOIN_BETA'),
    buttons: [
      {
        text: translate('DISMISS'),
        role: 'cancel',
      },
      {
        text: translate('JOIN_BETA'),
        handler: () => dispatch(updateUserAccount({ env: 'beta' })),
      },
    ],
  };
  const alert = await alertController.create(options);
  return alert.present();
};

const showOnProdWebsiteGoToBeta = () => {
  const options: ToastOptions = {
    message: translate('ON_PROD_GO_TO_BETA'),
    buttons: [
      {
        text: translate('DISMISS'),
        side: 'end',
        role: 'cancel',
      },
      {
        text: translate('GO_TO_BETA'),
        side: 'end',
        handler: () => {
          location.href = betaWebAppURL;
        },
      },
    ],
    color: 'dark',
  };
  return showGlobalToast(options);
};

export const exitBeta = () => async (dispatch, _getState) => {
  trackIntercomEvent('exit_beta');
  amplitudeLogEvent(AmplitudeEvents.exit_beta);
  await updateAccount({ env: 'prod' });
  await dispatch(updateUserAccount({ env: 'prod' }));
  // dispatch(downloadAndExtractUpdateFromChannel('prod'));
};

// export const downloadAndExtractUpdateFromChannel = (env: EnvString) => async (
//   dispatch,
//   _getState
// ) => {
//   dispatch(setUpdateAvailable(false));
//   const exitingBeta = env == 'prod' && swApi.env !== 'prod';
//   const showToast = env !== 'prod';
//   // only show toast for non-prod
//   // production silently updates in the background
//   try {
//     await Deploy.configure({ channel: env });
//     const update = await Deploy.checkForUpdate();
//     if (update.available) {
//       if (exitingBeta) {
//         showGlobalLoading({});
//       }
//       await Deploy.downloadUpdate((number) =>
//         dispatch(setDeployStatus(number, 0))
//       );
//       await Deploy.extractUpdate((number) =>
//         dispatch(setDeployStatus(100, number))
//       );
//       dispatch(setUpdateAvailable(true));
//       if (exitingBeta) {
//         hideGlobalLoading();
//       }
//       if (showToast) {
//         return showNewVersionAvailableToast();
//       }
//     } else {
//       console.debug('IONIC:: no update available for ', env);
//       if (swApi.env == env) return;
//       // native user no update available from deploy
//       // but we need to refresh to sync env with swApi
//       dispatch(setUpdateAvailable(true));
//       return showNewVersionAvailableToast();
//     }
//   } catch (err) {
//     console.debug('IONIC:: error downloading update');
//   }
// };

export async function showGlobalLoading(options: LoadingOptions) {
  const loading = await loadingController.create(options);
  return await loading.present();
}

export function hideGlobalLoading() {
  const loadingCtrl = document.querySelector('ion-loading');
  if (!loadingCtrl) return;
  loadingCtrl.dismiss();
}

export interface SetDeployStatus {
  type: TypeKeys.SET_DEPLOY_STATUS;
  downloadingProgress: number;
  extractingProgress: number;
}

export const setDeployStatus = (
  downloadingProgress: SetDeployStatus['downloadingProgress'],
  extractingProgress: SetDeployStatus['extractingProgress']
) => {
  const action: SetDeployStatus = {
    type: TypeKeys.SET_DEPLOY_STATUS,
    downloadingProgress,
    extractingProgress,
  };
  return action;
};
export interface UpdateAvailable {
  type: TypeKeys.UPDATE_AVAILABLE;
  updateAvailable: boolean;
}

function setUpdateAvailable(updateAvailable: boolean) {
  const action: UpdateAvailable = {
    type: TypeKeys.UPDATE_AVAILABLE,
    updateAvailable,
  };
  return action;
}
